import { SafeHtml } from '@angular/platform-browser';
import { KeyedCollection } from '../classes';
import { DiscussionEnum } from '../enums';
import { IContact } from '../Interfaces';
export namespace CRMDiscussion {
    export class CRMDiscussionModel {
        Attributes: KeyedCollection<IAttribute>;
        Id: string;
        LogicalName: string;
        Posts: Post[];
        Acep_Type: string;
        get Type() {
            let x = DiscussionEnum.Type[this.Acep_Type];
            return x;
        };
        audience: string;
        listCount: number;
        next: boolean;
        nextPage: string;
        nextPageUrl: string;
        page: number;
        pageCount: number;
        prev: boolean;
        prevPageUrl: string;
        prevPage: string;
        queriedCount: number;
        url: string;
    }

    export interface IAttribute {
        Id: string;
        LogicalName: string;
        Value: any;
    }


    export interface IPost {
        Attributes: KeyedCollection<any>;
        Audience: string;
        LogicalName: string;
        Location: DiscussionEnum.Location;
        Name: IContact;
        CreatedOn: Date;
        Acep_Type: string;
        Body: SafeHtml;
    }

    export class Post implements IPost {
        Attributes: KeyedCollection<any>;
        Audience: string;
        LogicalName: string;
        RoleEnum: string
        get Location() {
            return DiscussionEnum.Location[this.Audience];
        };
        Name: IContact;
        CreatedOn: Date;
        Acep_Type: string;
        get Type() {
            let x = DiscussionEnum.Type[this.Acep_Type];
            return x;
        }
        Body: SafeHtml;
    }
}




// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/classes/crm-discussion.model.ts